import React,{useState} from 'react';
import axios from 'axios';
import moment from 'moment';

import Modal from 'react-modal';

import './Modal.css';
import '../../../assets/css/style.css'
import Auxi from '../../../hoc/Auxi';
import Toast from '../CustomToast';


const customStyles = {
    content : {
        top                   : '50%',
        left                  : '50%',
        right                 : 'auto',
        bottom                : 'auto',
        marginRight           : '-50%',
        transform             : 'translate(-50%, -50%)'
    }
};



const AnseringRuleModal = (props) => {

    const [anseringRuleValue, setAnsweringRuleValue] = useState('');
    const [answeringItems, setAnsweringItems] = useState('');
    const [itemsArray, setItemsArray] = useState([]);

    //let itemsArray = [];

    function afterOpenModal() {
        setAnsweringRuleValue('1');
        const arr = ['1', '2', '3', '4', '5'];
        setItemsArray(arr);
        const items = itemsArray.map((value, index) => {

            return(<option value={value}> {value}</option>)

        });

        setAnsweringItems(items);
    }

    // let answeringItems = [<option value={""}></option>,
    //     <option value={'1'}>
    //     {'1'}
    //     </option>,
    //     <option value={'2'}>
    //     {'2'}
    //     </option>,
    //     <option value={'3'}>
    //     {'3'}
    //     </option>,
    //     <option value={'4'}>
    //     {'4'}
    //     </option>,
    //     <option value={'5'}>
    //     {'5'}
    //     </option>,
    // ];

    

    const selectChangeHandler = (evt) => {
        const index = itemsArray.indexOf(evt.target.value);
        if(index > -1){
            itemsArray.splice(index, 1);
        }
        
        console.log(itemsArray);

        itemsArray.splice(0, 0, evt.target.value);
        
        console.log(itemsArray);

        const items = itemsArray.map((value, index) => {

            return(<option value={value}> {value}</option>)

        });

        setAnsweringItems(items);

        setAnsweringRuleValue(evt.target.value);

        
    }

    


    return (
        <div className = "forward-modal">

            <Modal
                isOpen={props.modalIsOpen}
                onAfterOpen={afterOpenModal}
                onRequestClose={props.closeModal}
                style={customStyles}
                contentLabel="Deletion Modal"
            >
                <div className="card-body text-center" style={{width:"260px"}}>
                    <h5 style={{marginBottom:"20px"}}> Sort Answering Rule </h5>
                    <span className="modal-cross" onClick={props.closeModal}>x</span>
                    <select className="form-control"
                        onChange={selectChangeHandler}
                        value={anseringRuleValue} name="anseringRuleValue">

                        {answeringItems}

                    </select>
                    
                </div>
                    
            </Modal>
        </div>
    );

};

export default AnseringRuleModal;
